/** Build a friction entry from the raw hook arguments. */
export function schemaMismatchEntry(endpoint, issues, sample) {
    return {
        kind: "schema_mismatch",
        ts: new Date().toISOString(),
        endpoint,
        issues,
        sample,
    };
}
/** Serialize a friction entry as a single NDJSON line (trailing newline included). */
export function serializeFrictionLine(entry) {
    return `${JSON.stringify(entry)}\n`;
}
/**
 * JSON-stringify an arbitrary payload, capped at `max` chars so a huge response
 * body can't bloat the friction log. Falls back to String() for non-serializable
 * values (e.g. circular structures).
 */
export function truncateSample(data, max = 2000) {
    let s;
    try {
        s = JSON.stringify(data) ?? String(data);
    }
    catch {
        s = String(data);
    }
    if (s.length > max) {
        s = `${s.slice(0, max)}…[truncated ${s.length - max} chars]`;
    }
    return s;
}
//# sourceMappingURL=friction.js.map